import axios from 'axios'

import config from '../../config'

const createNotificationGroup = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/NotificationGroups`
  return axios.post(url, data)
}

export default createNotificationGroup
